import type { ReactElement } from 'react';
import { EyebrowLabel } from '@/shared/ui';

interface ReviewPageHeaderProps {
  readonly title: string;
}

/** 후기 쓰기·수정 머리 — 견적 요청과 같은 결(작은 영문 머리말·큰 굵은 제목·얇은 아랫선)과 오른쪽 한 줄 설명. */
export const ReviewPageHeader = ({ title }: ReviewPageHeaderProps): ReactElement => (
  <header className="flex flex-col gap-5 border-b border-foreground/10 pb-8 lg:flex-row lg:items-end lg:justify-between lg:gap-16">
    <div className="flex flex-col gap-4">
      <EyebrowLabel>Review</EyebrowLabel>
      <h1 className="text-[clamp(2.25rem,4.5vw,4rem)] leading-none font-bold tracking-[-0.03em]">
        {title}
      </h1>
    </div>
    <p className="max-w-md text-sm leading-relaxed text-muted-foreground lg:max-w-xl lg:pb-1 lg:text-right">
      받아 보신 제품은 어떠셨나요? 남겨 주신 후기는 다른 기업 담당자분들이 제작을 결정하는 데 큰
      도움이 돼요.
    </p>
  </header>
);
